import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaterManagementComponent } from './water-management/water-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { CheckboxModule } from 'ZalamoLibrary/src/lib/ui/form/checkbox/checkbox.module';
import { MatInputModule } from '@angular/material/input';
import { FormModule } from 'ZalamoLibrary/src/lib/ui/form/form.module';
import { MatSelectModule } from '@angular/material/select';
import { WatermarkInlinePickerComponent } from './watermark-inline-picker/watermark-inline-picker.component';
import { WatermarkPreviewComponent } from './watermark-preview/watermark-preview.component';
import { ImageListPickerModule } from 'ZalamoLibrary/src/lib/ui/form/image-list-picker/image-list-picker.module';
import { MatIconModule } from '@angular/material/icon';
import { LanguageModule } from 'ZalamoLibrary/src/lib/zalamo/language/language.module';
import { SingleFileUploaderModule } from 'ZalamoLibrary/src/lib/upload/components/single-file-uploader/single-file-uploader.module';
import { WatermarkFileManagementComponent } from './watermark-file-management/watermark-file-management.component';
import { ResponsivenessModule } from 'ZalamoLibrary/src/lib/ui/responsive/responsiveness/responsiveness.module';
import { WatermarkForImageManagerComponent } from './watermark-for-image-manager/watermark-for-image-manager.component';
import { NgxMoveableModule } from 'ngx-moveable';
import { ImagesModule } from 'ZalamoLibrary/src/lib/ui/images/images.module';
import { LogoWatermarkPreviewComponent } from './logo-watermark-preview/logo-watermark-preview.component';
import { WatermarkUniversalConfigComponent } from './watermark-universal-config/watermark-universal-config.component';
import { WatermarkUniversalInlinePickerComponent } from './watermark-universal-inline-picker/watermark-universal-inline-picker.component';
import { WatermarkForPhotoManagerComponent } from './watermark-for-photo-manager/watermark-for-photo-manager.component';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { SideDialogModule } from 'ZalamoLibrary/src/lib/ui/side-dialog/dialog-module';
import { TranslationsModule } from '@ui/nls/translations/translations.module';
import { UserModule } from 'ZalamoLibrary/src/lib/zalamo/user/user.module';

@NgModule({
  declarations: [
    WaterManagementComponent,
    WatermarkInlinePickerComponent,
    WatermarkPreviewComponent,
    WatermarkFileManagementComponent,
    WatermarkForImageManagerComponent,
    LogoWatermarkPreviewComponent,
    WatermarkUniversalConfigComponent,
    WatermarkUniversalInlinePickerComponent,
    WatermarkForPhotoManagerComponent,
  ],
  exports: [
    WaterManagementComponent,
    WatermarkInlinePickerComponent,
    WatermarkUniversalInlinePickerComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
    PortalModule,
    CheckboxModule,
    MatInputModule,
    MatSelectModule,
    ButtonModule,
    SideDialogModule,
    ImageListPickerModule,
    MatIconModule,
    LanguageModule,
    SingleFileUploaderModule,
    ResponsivenessModule,
    NgxMoveableModule,
    ImagesModule,
    ImageLoaderModule,
    TranslationsModule,
    UserModule,
  ],
})
export class WatermarkManagementModule {}
